export default {
  label: 'Senden an',
  counter: '{{current}} von {{max}}',
  default_badge: 'Standard',
  remove: '{{email}} entfernen',
  add_back: 'Wieder hinzufügen',
  empty: 'Fügen Sie mindestens eine E-Mail-Adresse hinzu.',
  add_label: 'E-Mail-Adresse hinzufügen',
  placeholder: 'name@beispiel.de',
  add: 'Hinzufügen',
  hint: 'Bis zu {{max}} Adressen. Jede bekommt ihre eigene E-Mail.',
  hint_full: 'Mehr Adressen passen nicht auf diese Liste. Entfernen Sie eine, um eine andere hinzuzufügen.',
  errors: {
    full: 'Sie können höchstens {{max}} Adressen hinzufügen.',
    invalid: 'Geben Sie eine E-Mail-Adresse wie name@beispiel.de ein.',
    duplicate: '{{email}} steht bereits auf der Liste.',
  },
};
